import { useMatches as useMatchesRR } from 'react-router'
import { RouteMatch } from './types'

/**
 * Typed wrapper around react-router's `useMatches`. The upstream hook returns
 * `UIMatch[]` where `handle` is `unknown`; this wrapper narrows `handle` to
 * our {@link RouteHandle}, eliminating per-call-site casts.
 */
export const useMatches = (): RouteMatch[] => useMatchesRR() as RouteMatch[]
